export default {"src":"/_next/static/media/assets.ee458a4f.svg","height":152,"width":240,"blurWidth":0,"blurHeight":0};